//function for sending chosen event
export async function sendTagGoogleSubmit(email, phone, extras = {}) {
    console.log(email, phone);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'enhanced_conversion',
        'email': email,
        'phone': phone
    });

    await new Promise((resolve) => setTimeout(resolve, 100));

    const {
        businessPartnerNumber = '',   // from finishAcquisition response
        contractNumber = '',          // from finishAcquisition response
        tariffId = 'Vertrag',         // fallback when tariff id is not available
        value = 0.00,                 // required, hardcoded
        currency = 'EUR'              // required, hardcoded
    } = extras || {};

    const purchasePayload = {
        event: 'purchase',
        customer_id: businessPartnerNumber ? String(businessPartnerNumber) : '',
        transaction_id: contractNumber ? String(contractNumber) : '',
        value: value,
        currency: currency,
        email: email || '',
        phone_number: phone || '',
        items: [
            {
                item_id: tariffId || 'Vertrag',
                item_name: 'Klickstrecke'
            }
        ]
    };

    console.log(purchasePayload);

    window.dataLayer.push(purchasePayload);

    return true;
}

//function for sending chosen event
export async function sendTag(eventId, manager) {

    console.log(eventId, manager);
    let events = [];
    if(manager === 'google') {
        events = [
            { id: 'jetzt_wechseln', event: 'Jetzt wechseln1', eventCategory: 'Navigation', eventAction: 'click', eventLabel: '00_Klick_Jetzt-wechseln', page: '/', buttonLocation: 'header_startseite_1', buttonName: 'jetzt_wechseln' },
            { id: 'jetzt_wechseln_mobile', event: 'Jetzt wechseln2', eventCategory: 'Navigation', eventAction: 'click', eventLabel: '00_Klick_Jetzt-wechseln', page: '/', buttonLocation: 'header_startseite_1', buttonName: 'jetzt_wechseln' },
            { id: 'TarifWahlen1', event: 'Tarif wählen1', eventCategory: 'Tarif Selection', eventAction: 'click', eventLabel: '01_Klick_Tarif_wählen', page: '/', buttonLocation: 'startseite', buttonName: 'tarif_waehlen' },
            { id: 'TarifWahlen2', event: 'Tarif wählen2', eventCategory: 'Tarif Selection', eventAction: 'click', eventLabel: '01-2_Klick_Tarif_wählen', page: '/produktauswahl/', buttonLocation: 'produktauswahl', buttonName: 'tarif_waehlen' },
            { id: 'next-step-2', event: 'Schritt 1', eventCategory: 'Form', eventAction: 'click', eventLabel: '02_Formular_Step_01_Daten', page: '/multistep-form/', buttonLocation: 'multistep_form_schritt_1', buttonName: 'weiter' },
            { id: 'next-step-3', event: 'Schritt 2', eventCategory: 'Form', eventAction: 'click', eventLabel: '03_Formular_Step_02_Belieferung', page: '/multistep-form/', buttonLocation: 'multistep_form_schritt_2', buttonName: 'weiter' },
            { id: 'next-step-4', event: 'Schritt 3', eventCategory: 'Form', eventAction: 'click', eventLabel: '05_Formular_Step_03_Zahlung', page: '/multistep-form/', buttonLocation: 'multistep_form_schritt_3', buttonName: 'weiter' },
            { id: 'zahlungspflichtig_bestellen', event: 'Schritt 4', eventCategory: 'Form', eventAction: 'click', eventLabel: '06_Formular_Step_04_Beauftragung', page: '/multistep-form/', buttonLocation: 'multistep_form_letzter_schritt', buttonName: 'zahlungspflichtig_bestellen' }
        ];

        const eventIndex = events.findIndex(event => event.id === eventId);

        if (eventIndex !== -1) {
            const event = events[eventIndex];
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                'event': event.event,
                'eventCategory': event.eventCategory,
                'eventAction': event.eventAction,
                'eventLabel': event.eventLabel,
                'page': event.page,
                'buttonLocation': event.buttonLocation,
                'buttonName': event.buttonName
            });
        } else {
            console.warn(`Event with ID '${eventId}' not found in Google events.`);
        }

    } else {
        events = [
            { id: 'TarifWahlen1', category: 'Home', action: 'Klick', label: 'Tarif wählen1' },
            { id: 'TarifWahlen2', category: 'Home', action: 'Klick', label: 'Tarif wählen2' },
            { id: 'next-step-2', category: 'Formular', action: 'Klick', label: 'Schritt 1' },
            { id: 'next-step-3', category: 'Formular', action: 'Klick', label: 'Schritt 2' },
            { id: 'next-step-4', category: 'Formular', action: 'Klick', label: 'Schritt 3' },
            { id: 'zahlungspflichtig_bestellen', category: 'Formular', action: 'Klick', label: 'Schritt 4' }
        ];

        const eventIndex = events.findIndex(event => event.id === eventId);

        if (eventIndex !== -1) {
            const event = events[eventIndex];
            window._paq = window._paq || [];

            window._paq.push(['trackEvent', event.category, event.action, event.label]);
        } else {
            console.warn(`Event with ID '${eventId}' not found in Piwik events.`);
        }

    }
    return true;
}

jQuery(document).ready(function ($) {
    $(document).on('click', '[id^="choose-tariff-btn"]', function (e) {
        //matomo simple push
        sendTag('TarifWahlen2', 'matomo');

        //google simple push
        sendTag('TarifWahlen2', 'google');
    });

    $(document).on('click', '#jetzt_wechseln', function (e) {
        //google simple push
        sendTag('jetzt_wechseln', 'google');
    });

    $(document).on('click', '#jetzt_wechseln_mobile', function (e) {
        //google simple push
        sendTag('jetzt_wechseln_mobile', 'google');
    });
});